import {useState} from 'react'
import {differenceInCalendarMonths, parseISO} from 'date-fns'
import dayjs from 'dayjs'
import Big from 'big.js'
import {Space} from 'antd'
import styles from './RequestForecastForm.module.scss'
// import useStore from 'base/store'
import {
  Button,
  Box,
  Text,
  CentsMoney,
  RotateArrowThirdIcon,
  RotateArrowFourthIcon,
} from 'common/components'
import {
  formatDate,
  formatMoney,
  maybePluralize,
  totalNumberFromArray,
  isItemPureDrawdown,
  isItemRepayment,
  getInitialForecast,
} from 'common/helpers'
import {
  ForecastItem as ForecastItemInterface,
  ForecastFormItem,
} from 'common/types'
import {RequestForecastList, RequestForecastItemAdd} from '..'
import {useCreateVariationForecast} from '../api.variation'

interface RequestForecastFormProps {
  isConfirm?: boolean
  request: any
  transactions: any[]
  forecast: ForecastItemInterface[]
  onClose: () => void
}

interface CreateForcastProps {
  request: any
  openDate: Date
  variationDate: Date
  maturityDate: Date
  loanValue: number
  ddTransactions: any[]
  initDrawdownAmount: number
  onClose: () => void
}

interface UpdateForecastProps {
  requestUuid: string
  forecast: ForecastItemInterface[]
  project: any
  openDate: Date
  variationDate: Date
  loanValue: number
  ddTransactions: any[]
}

interface SummaryRowProps {
  isDrawdowns?: boolean
  count: number
  total: number
  loanValue?: number
  fixedAmount?: number
}

export default function VariationRequestForecastForm({
  isConfirm,
  request,
  transactions,
  forecast,
  onClose,
}: RequestForecastFormProps) {
  // const openDate = parseISO(request.openDate)
  // const maturityDate = parseISO(request.maturityDate)
  // const {loanValue} = request
  // const drawdownTransactions: any[] = request.projectTransactions?.filter(
  const drawdownTransactions: any[] = transactions?.filter(
    (x:any) => ( isItemPureDrawdown(x) && (!!x.amount) && (!!x.date) )
  ).map((x:any) => ({
    date: parseISO(x.date),
    amount: x.amount || 0,
    type: x.type,
    notes: x.notes,
    initialDrawdown: (x.type === 'initial-drawdown'),
  })).sort(
    (a:any, b:any) => ( dayjs(a.date).isBefore(dayjs(b.date)) ? -1:1 )
  ) || []
  const ddTransTotalAmount = drawdownTransactions.reduce((accu:number, item:any) => {
    return accu + item.amount
  }, 0)
  const project = request.project
  const openDate = parseISO(project.openDate)
  const loanQuotaValue = project.totalAmount

  if (!request) return null
  
  const variationDate = parseISO(!isConfirm ? request.startDate : request.startDateConfirmed)
  const maturityDate = parseISO(!isConfirm ? request.maturityDate : request.maturityDateConfirmed)
  const increaseAmount = request.increaseAmount
  const initVariationDDValue = !isConfirm ? request.initialDrawdown : request.initialDrawdownConfirmed
  const loanValue = loanQuotaValue + increaseAmount - ddTransTotalAmount
  // console.table({
  //   loanValue, loanQuotaValue, increaseAmount, ddTransTotalAmount
  // })
  // console.table(drawdownTransactions)
  
  // console.log(request)
  // console.table(request.milestones.map((x:any) => ({
  //   type: x.type,
  //   passed: x.passed
  // })))
  // console.log(project)
  // console.log(openDate)
  // console.log(variationDate)
  // console.log(maturityDate)
  // console.log(loanValue)
  // console.table(drawdownTransactions)
  // console.log(ddTransTotalAmount)

  return (
    !!forecast?.length ?
    <UpdateForecast
      ddTransactions={drawdownTransactions}
      loanValue={loanValue}
      openDate={openDate}
      variationDate={variationDate}
      forecast={forecast}
      requestUuid={request.uuid}
      project={project}
    />
    :
    <CreateForcast
      ddTransactions={drawdownTransactions}
      loanValue={loanValue}
      openDate={openDate}
      variationDate={variationDate}
      maturityDate={maturityDate}
      request={request}
      initDrawdownAmount={initVariationDDValue}
      onClose={onClose}
    />
  )
}

const CreateForcast = ({
  request,
  openDate,
  loanValue,
  ddTransactions,
  initDrawdownAmount,
  variationDate,
  maturityDate,
  onClose,
}: CreateForcastProps) => {
  const [newForecast, setNewForecast] = useState<ForecastFormItem[]>(
    getInitialForecast(loanValue, variationDate, maturityDate, initDrawdownAmount)
  )

  // console.log('form...')
  // console.table([{loanValue, openDate, variationDate, maturityDate}])
  // console.table(ddTransactions)
  // console.table(newForecast)

  // const setForecastCreatedProjects = useStore(
  //   (state) => state.setForecastCreatedProjects
  // )
  const {mutate: createForecast, isMutating: isCreateForecastMutating} =
    useCreateVariationForecast(
      request.project.uuid,
      onClose,
      // setForecastCreatedProjects
    )

  const handleFinish = () => {
    const payload: any = {
      variationRequest: request.uuid,
      items: newForecast.map((item) => ({
        amount: item.amount,
        type: item.type,
        date: formatDate(item.date, 'server'),
        initialDrawdown: !!item.initialDrawdown,
      }))
    }
    createForecast(payload)
  }

  if (!newForecast?.length) return (
    <Text mb={24} color="redError">No initial forecast available!</Text>
  )

  // const startDate = ddTransactions?.[0]?.date
  const endDate = newForecast?.at(-1)?.date
  if (
    !openDate ||
    // !startDate || 
    !endDate
  ) return null
  // const months = differenceInCalendarMonths(endDate, startDate)
  const months = differenceInCalendarMonths(endDate, openDate)
  const currentLoanValue = loanValue
  const drawdowns = newForecast.filter((item) => isItemPureDrawdown(item))
  const repayments = newForecast.filter((item) => isItemRepayment(item))
  const drawdownsTotalAmount = totalNumberFromArray(drawdowns, 'amount')
  const minDate = ddTransactions?.at(-1).date || openDate
  const fixedTransTotal = !ddTransactions?.length ? 0 : totalNumberFromArray(ddTransactions, 'amount')
  // const isOverLimit = drawdownsTotalAmount > currentLoanValue

  return (
    <>
      {/* <Text align="center" mb={24}>
        This forecast is created automatically. The entire loan amount is evenly
        distributed over the number of months. You can add and remove estimates
        and adjust the current table.
      </Text> */}
      
      <RequestForecastList
        fixedForecast={ddTransactions}
        forecast={newForecast}
        months={months}
        openDate={openDate}
        loanValue={currentLoanValue}
        setNewForecast={setNewForecast}
        hideEmpty={true}
        // variationDate={variationDate}
      />
      <RequestForecastItemAdd
        minDate={minDate}
        forecast={newForecast}
        loanValue={currentLoanValue}
        setNewForecast={setNewForecast}
        isVariation={true}
      />
      <Box>
        <SummaryRow
          isDrawdowns
          count={drawdowns.length}
          total={drawdownsTotalAmount}
          loanValue={currentLoanValue}
          fixedAmount={fixedTransTotal}
        />
        {Boolean(repayments.length) && (
          <SummaryRow
            count={repayments.length}
            total={totalNumberFromArray(repayments, 'amount')}
            loanValue={loanValue}
          />
        )}
      </Box>
      <Box align="right" mt={24}>
        <Button
          loading={isCreateForecastMutating}
          disabled={
            !drawdowns.length // || isOverLimit
          }
          onClick={handleFinish}
        >
          Save forecast
        </Button>
      </Box>
    </>
  )
}

const UpdateForecast = ({
  requestUuid,
  project,
  openDate,
  variationDate,
  loanValue,
  forecast,
  ddTransactions
}: UpdateForecastProps) => {
  const currentForecast: ForecastFormItem[] = forecast.map((item) => ({
    uuid: item.uuid,
    type: item.type,
    date: parseISO(item.value.date),
    amount: item.value.amount,
    initialDrawdown: item.initialDrawdown
  }))
  const drawdowns = currentForecast.filter((item) => isItemPureDrawdown(item))
  const repayments = currentForecast.filter((item) => isItemRepayment(item))
  const drawdownsTotalAmount = totalNumberFromArray(drawdowns, 'amount')
  // const startDate = ddTransactions[0].date
  const endDate = currentForecast.at(-1).date
  // const months = differenceInCalendarMonths(endDate, startDate)
  const months = differenceInCalendarMonths(endDate, openDate) // startDate)
  const minDate = ddTransactions?.at(-1).date || variationDate
  const fixedTransTotal = !ddTransactions?.length ? 0 : totalNumberFromArray(ddTransactions, 'amount')

  return (
    <>
      <RequestForecastList
        fixedForecast={ddTransactions}
        forecast={currentForecast}
        projectUuid={project.uuid}
        requestUuid={requestUuid}
        openDate={openDate}
        months={months}
        loanValue={loanValue}
        hideEmpty={true}
      />
      <RequestForecastItemAdd
        projectUuid={project.uuid}
        requestUuid={requestUuid}
        minDate={minDate}
        forecast={currentForecast}
        loanValue={loanValue}
        isVariation={true}
      />
      <Box>
        <SummaryRow
          isDrawdowns
          count={drawdowns.length}
          total={drawdownsTotalAmount}
          loanValue={loanValue}
          fixedAmount={fixedTransTotal}
        />
        {Boolean(repayments.length) && (
          <SummaryRow
            count={repayments.length}
            total={totalNumberFromArray(repayments, 'amount')}
            loanValue={loanValue}
          />
        )}
      </Box>
    </>
  )
}

const SummaryRow = ({
  isDrawdowns,
  count,
  total,
  loanValue,
  fixedAmount = 0
}: SummaryRowProps) => {
  const bigTotal = Big(total).round(2).toNumber()
  const bigLoanValue = Big(loanValue).round(2).toNumber()

  const overlimitError =
    isDrawdowns && bigTotal !== bigLoanValue ? (
      bigTotal > bigLoanValue ? (
        <>
          Estimation is higher than
          <br />
          the loan amount for {formatMoney(bigTotal - bigLoanValue, {cents: true})}
        </>
      ) : (
        <>
          Estimation is less than
          <br />
          the loan amount for {formatMoney(bigLoanValue - bigTotal, {cents: true})}
        </>
      )
    ) : undefined

  return (
    <div className={styles.summary}>
      <div />
      <Space>
        {isDrawdowns ? <RotateArrowThirdIcon /> : <RotateArrowFourthIcon />}
        <Text weight="demiBold">
          {maybePluralize(count, isDrawdowns ? 'drawdown' : 'repayment')}
        </Text>
      </Space>
      <Box align="right">
        <CentsMoney
          value={bigTotal + fixedAmount}
          size="3xl"
          weight="medium"
          color={overlimitError ? 'redError' : undefined}
        />
        {overlimitError && (
          <Text size="xs" color="redError" weight="medium" mt={6}>
            {overlimitError}
          </Text>
        )}
      </Box>
    </div>
  )
}
